<template>
  <Transition name="modal-fade">
    <div
      v-if="modelValue"
      id="hmcModal"
      class="hmc-modal-overlay"
      @click.self="CloseModal">
      
      <!-- Embedded SVG Sprite Symbols -->
      <svg style="display: none;">
        <defs>
          <symbol id="q-p1" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="8" r="3.2"/><path d="M5.5 19.5c.6-3.6 3.2-5.6 6.5-5.6s5.9 2 6.5 5.6"/></g></symbol>
          <symbol id="q-p2" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="9" cy="8.5" r="2.8"/><path d="M3.6 19c.5-3.1 2.6-4.8 5.4-4.8s4.9 1.7 5.4 4.8"/><circle cx="16.4" cy="9" r="2.4"/><path d="M15.3 14.2c2.6 0 4.6 1.5 5.1 4.4"/></g></symbol>
          <symbol id="q-p3" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="12" cy="7.5" r="2.6"/><path d="M7.4 18.5c.5-3 2.3-4.6 4.6-4.6s4.1 1.6 4.6 4.6"/><circle cx="5.6" cy="9.6" r="2"/><path d="M2.2 18c.3-2.2 1.6-3.6 3.4-3.6"/><circle cx="18.4" cy="9.6" r="2"/><path d="M21.8 18c-.3-2.2-1.6-3.6-3.4-3.6"/></g></symbol>
          <symbol id="q-bld" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="5" y="3.5" width="14" height="17" rx="1.5"/><path d="M9 7.5h2M13 7.5h2M9 11h2M13 11h2M9 14.5h2M13 14.5h2M10.5 20.5v-3h3v3"/></g></symbol>
          <symbol id="q-pg1" viewBox="0 0 24 24"><rect x="7" y="4" width="10" height="16" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.8"/></symbol>
          <symbol id="q-pg2" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><rect x="9" y="3" width="10" height="15" rx="1.5"/><path d="M6.5 6v13a1.5 1.5 0 0 0 1.5 1.5h9"/></g></symbol>
          <symbol id="q-pg3" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><rect x="10" y="2.5" width="10" height="14" rx="1.5"/><path d="M7.5 5v12.5A1.5 1.5 0 0 0 9 19h8.5"/><path d="M5 7.5v12.5A1.5 1.5 0 0 0 6.5 21.5H15"/></g></symbol>
          <symbol id="q-clr" viewBox="0 0 24 24"><circle cx="8.5" cy="9.5" r="5" fill="#06b6d4" opacity=".9"/><circle cx="15.5" cy="9.5" r="5" fill="#ec4899" opacity=".85"/><circle cx="12" cy="15.5" r="5" fill="#facc15" opacity=".9"/></symbol>
          <symbol id="q-bw" viewBox="0 0 24 24"><circle cx="12" cy="12" r="7" fill="#111827"/></symbol>
          <symbol id="q-q" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="8.5"/><path d="M9.7 9.5a2.4 2.4 0 1 1 3.3 2.2c-.7.3-1 .8-1 1.5v.6"/></g><circle cx="12" cy="16.7" r="1" fill="currentColor"/></symbol>
          <symbol id="q-let" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M8 6h6l3 3v9H8z"/><path d="M14 6v3h3"/></g></symbol>
          <symbol id="q-tab" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M5.5 2.5h9l4 4v15h-13z"/><path d="M14.5 2.5v4h4"/></g></symbol>
          <symbol id="i-chat" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 4v-4H6.5A2.5 2.5 0 0 1 4 13.5z"/></g></symbol>
        </defs>
      </svg>

      <!-- Modal Card -->
      <div class="mcard" :class="{ 'ai-mode': active_tab === 'ai' }">
        <!-- Close Button -->
        <button
          type="button"
          class="mx"
          aria-label="Close"
          @click="CloseModal">
          ✕
        </button>

        <!-- Mode Switcher Tabs -->
        <div class="mode-tabs">
          <button
            type="button"
            class="mode-tab-btn"
            :class="{ active: active_tab === 'ai' }"
            @click="SwitchTab('ai')">
            <svg class="tab-icon" viewBox="0 0 24 24">
              <path
                d="M12 0C12 6.627 6.627 12 0 12C6.627 12 12 17.373 12 24C12 17.373 17.373 12 24 12C17.373 12 12 6.627 12 0Z"
                fill="#ffffff"
                stroke="#000000"
                stroke-width="1">
              </path>
            </svg>
            <span>Ask Our AI</span>
          </button>
          <button
            type="button"
            class="mode-tab-btn"
            :class="{ active: active_tab === 'quiz' }"
            @click="SwitchTab('quiz')">
            <svg class="tab-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 11l3 3L22 4" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span>Help Me Choose</span>
          </button>
        </div>

        <!-- ================= MODE 1: ASK OUR AI ================= -->
        <div v-if="active_tab === 'ai'" class="ai-view-container">
          <div class="ai-header">
            <span class="m-eyebrow">AI Product Specialist</span>
            <h3>Ask Our AI Assistant</h3>
            <p class="ai-desc">
              Ask any question to find the best copiers, compare speeds, or get lease pricing recommendations.
            </p>
          </div>

          <!-- Chat Messages Area -->
          <div ref="chat_body_ref" class="ai-chat-body">
            <!-- Initial Bot Message -->
            <div class="chat-row bot">
              <div class="bot-avatar">
                <svg viewBox="0 0 24 24" fill="currentColor" class="sparkle-avatar">
                  <path d="M12 2l1.9 5.9L20 10l-6.1 2L12 18l-1.9-6L4 10l6.1-2.1z" />
                </svg>
              </div>
              <div class="bubble bot-bubble">
                <div class="bot-text">
                  Hello! I'm your <strong>1-800 Office Solutions AI Assistant</strong>. Tell me about your team size, monthly volume, or budget, and I'll find the perfect equipment for you!
                </div>
              </div>
            </div>

            <!-- Conversation Starters (Shown when conversation is empty) -->
            <div v-if="chat_messages.length === 0" class="starters-wrap">
              <div class="starters-label">Try one of these:</div>
              <div class="starters-grid">
                <button
                  v-for="(starter, s_idx) in conversation_starters"
                  :key="s_idx"
                  type="button"
                  class="starter-chip"
                  @click="SelectStarter(starter.prompt)">
                  <span class="starter-icon">{{ starter.icon }}</span>
                  <span class="starter-text">{{ starter.text }}</span>
                </button>
              </div>
            </div>

            <!-- Dynamic Messages List -->
            <div
              :key="m_idx"
              class="chat-row"
              v-for="(msg, m_idx) in chat_messages"
              :class="msg.role === 'human' ? 'user' : 'bot'">
              <div v-if="msg.role === 'ai'" class="bot-avatar">
                <svg
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  class="sparkle-avatar">
                  <path d="M12 2l1.9 5.9L20 10l-6.1 2L12 18l-1.9-6L4 10l6.1-2.1z" />
                </svg>
              </div>
              <div
                class="bubble"
                :class="msg.role === 'human' ? 'user-bubble' : 'bot-bubble'">
                <div v-html="FormatMessage(msg.message)"></div>

                <!-- Recommended Product Cards -->
                <div
                  class="ai-prod-grid"
                  v-if="msg.recommended_products && msg.recommended_products.length > 0">
                  <div
                    :key="prod.id"
                    class="ai-prod-card"
                    @click="ConfigureProduct(prod)"
                    v-for="prod in msg.recommended_products">
                    <div class="ai-prod-thumb-box">
                      <img
                        :alt="prod.name"
                        class="ai-prod-thumb"
                        :src="ProductImage(prod)">
                      </img>
                      <span class="ai-prod-badge">Free delivery</span>
                    </div>

                    <div class="ai-prod-content">
                      <div class="ai-prod-capsule">{{ FormatProductSpecsSummary(prod) }}</div>
                      <div class="ai-prod-title">{{ prod.name }}</div>
                      <div class="ai-prod-inc">✓ Service &amp; toner included</div>

                      <div class="ai-prod-action-row">
                        <div class="ai-prod-price">
                          <template v-if="GetProductPrice(prod) > 0">
                            <span class="est">EST.</span>
                            <span class="val">${{ GetProductPrice(prod) }}<small>/mo</small></span>
                          </template>
                          <template v-else>
                            <span class="val custom-quote">Custom Quote</span>
                          </template>
                        </div>
                        <button
                          type="button"
                          class="ai-prod-btn"
                          @click.stop="ConfigureProduct(prod)">
                          Configure →
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Thinking / Loading Indicator -->
            <div v-if="is_generating" class="chat-row bot">
              <div class="bot-avatar">
                <svg viewBox="0 0 24 24" fill="currentColor" class="sparkle-avatar">
                  <path d="M12 2l1.9 5.9L20 10l-6.1 2L12 18l-1.9-6L4 10l6.1-2.1z" />
                </svg>
              </div>
              <div class="bubble bot-bubble typing-bubble">
                <span class="typing-dot"></span>
                <span class="typing-dot"></span>
                <span class="typing-dot"></span>
              </div>
            </div>
          </div>

          <!-- Chat Input Area -->
          <div class="ai-input-area">
            <div class="prompt-input-wrapper">
              <textarea
                ref="input_ref"
                v-model="user_input"
                class="prompt-textarea"
                rows="1"
                placeholder="Ask about copiers, paper sizes, speed, volume, or leasing..."
                @keydown.enter.exact.prevent="HandleSendPrompt"
              ></textarea>
              <button
                type="button"
                class="send-btn"
                :disabled="!user_input.trim() || is_generating"
                @click="HandleSendPrompt">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M22 2L11 13" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
            <div class="ai-footer-note">
              <span>Powered by 1-800 AI · Press Enter to send</span>
              <a href="#" class="switch-link" @click.prevent="SwitchTab('quiz')">
                Prefer a 4-question quiz? Click here
              </a>
            </div>
          </div>
        </div>

        <!-- ================= MODE 2: C8 HELP ME CHOOSE QUIZ ================= -->
        <div v-else class="quiz-view-container">
          <span class="m-eyebrow">Help me choose</span>
          <h3>Tell us about your office</h3>

          <!-- Q1: People Count -->
          <div class="mq">
            <div class="ql">How many people will use it?</div>
            <div class="qchips">
              <button
                v-for="opt in people_options"
                :key="opt.value"
                type="button"
                class="qchip"
                :class="{ on: selected_people === opt.value }"
                @click="selected_people = opt.value">
                <svg><use :href="`#${opt.icon}`"/></svg>
                <span>{{ opt.label }}</span>
              </button>
            </div>
          </div>

          <!-- Q2: Monthly Volume -->
          <div class="mq">
            <div class="ql">Estimated print volume per month</div>
            <div class="qchips c3">
              <button
                v-for="opt in volume_options"
                :key="opt.value"
                type="button"
                class="qchip"
                :class="{ on: selected_volume === opt.value }"
                @click="selected_volume = opt.value">
                <svg><use :href="`#${opt.icon}`"/></svg>
                <span>{{ opt.label }}</span>
              </button>
            </div>
          </div>

          <!-- Q3: Color or B&W -->
          <div class="mq">
            <div class="ql">What do you print?</div>
            <div class="qchips c3">
              <button
                v-for="opt in color_options"
                :key="opt.value"
                type="button"
                class="qchip"
                :class="{ on: selected_color === opt.value }"
                @click="selected_color = opt.value">
                <svg><use :href="`#${opt.icon}`"/></svg>
                <span>{{ opt.label }}</span>
              </button>
            </div>
          </div>

          <!-- Q4: Paper Size -->
          <div class="mq">
            <div class="ql">Largest paper size</div>
            <div class="qchips c2">
              <button
                v-for="opt in paper_options"
                :key="opt.value"
                type="button"
                class="qchip"
                :class="{ on: selected_paper === opt.value }"
                @click="selected_paper = opt.value">
                <svg><use :href="`#${opt.icon}`"/></svg>
                <span>{{ opt.label }}</span>
              </button>
            </div>
          </div>

          <!-- Primary CTA Button -->
          <button
            type="button"
            class="btn-b"
            @click="ApplyQuizMatches">
            Show my matches
          </button>

          <!-- Secondary Link to AI -->
          <a
            class="mai"
            role="button"
            @click.prevent="SwitchTab('ai')">
            <svg
              viewBox="0 0 24 24"
              style="width: 15px; height: 15px;">
              <path
                d="M12 0C12 6.627 6.627 12 0 12C6.627 12 12 17.373 12 24C12 17.373 17.373 12 24 12C17.373 12 12 6.627 12 0Z"
                fill="#ffffff"
                stroke="#000000"
                stroke-width="1.2">
              </path>
            </svg>
            <span>Or ask our AI</span>
          </a>
        </div>

      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, computed, watch, nextTick } from 'vue'
import axios from 'axios'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
import { CalculateProductMonthlyPrice, IsProductQuotable } from '@/mixins/PricingMixins.ts'
import { FormatProductSpecsSummary } from '@/mixins/ProductMixins.ts'

const props = withDefaults(defineProps<{
  modelValue: boolean
  initialMode?: 'ai' | 'quiz'
}>(), {
  modelValue: false,
  initialMode: 'ai'
})

const emit = defineEmits<{
  (e: 'update:modelValue', val: boolean): void
  (e: 'close'): void
}>()

const store = useGlobalsStore()
const { filters, products, manufacturers } = storeToRefs(store)

// --- Active Tab State ---
const active_tab = ref<'ai' | 'quiz'>(props.initialMode)

watch(() => props.initialMode, (new_mode) => {
  if (new_mode) active_tab.value = new_mode
})

watch(() => props.modelValue, (is_open) => {
  if (is_open) {
    if (props.initialMode) active_tab.value = props.initialMode
    nextTick(() => {
      if (active_tab.value === 'ai') {
        input_ref.value?.focus()
        ScrollChatToBottom()
      }
    })
  }
})

function SwitchTab(tab: 'ai' | 'quiz') {
  active_tab.value = tab
  if (tab === 'ai') {
    nextTick(() => {
      input_ref.value?.focus()
      ScrollChatToBottom()
    })
  }
}

function CloseModal() {
  emit('update:modelValue', false)
  emit('close')
}

// --- Quiz Mode Options ---
const people_options = [
  { value: '1-10', label: '1–10', icon: 'q-p1' },
  { value: '10-25', label: '10–25', icon: 'q-p2' },
  { value: '25-50', label: '25–50', icon: 'q-p3' },
  { value: '50+', label: '50+', icon: 'q-bld' },
]

const volume_options = [
  { value: 'low', label: 'Less than 3,000', icon: 'q-pg1' },
  { value: 'mid', label: '3,000–10,000', icon: 'q-pg2' },
  { value: 'high', label: '10,000+', icon: 'q-pg3' },
]

const color_options = [
  { value: 'color', label: 'Color', icon: 'q-clr' },
  { value: 'bw', label: 'Black & white', icon: 'q-bw' },
  { value: 'any', label: 'Not sure', icon: 'q-q' },
]

const paper_options = [
  { value: 'letter', label: 'Letter / Legal', icon: 'q-let' },
  { value: 'tabloid', label: 'Up to 11×17', icon: 'q-tab' },
]

// Quiz State
const selected_people = ref('10-25')
const selected_volume = ref('mid')
const selected_color = ref('color')
const selected_paper = ref('letter')

function ApplyQuizMatches() {
  const new_filters = { ...filters.value }

  // 1. Color filter
  if (selected_color.value === 'color') {
    new_filters.copier_colors = ['Color']
  } else if (selected_color.value === 'bw') {
    new_filters.copier_colors = ['Black & White']
  } else {
    new_filters.copier_colors = []
  }

  // 2. Paper size filter
  if (selected_paper.value === 'tabloid') {
    new_filters.paper_sizes = ['11x17', 'Ledger', 'Tabloid', 'A3']
  } else {
    new_filters.paper_sizes = ['Letter', 'Legal', 'A4']
  }

  // 3. Speed estimate based on people & volume
  if (selected_people.value === '1-10') {
    new_filters.speed_minimum = 0
    new_filters.speed_maximum = 35
  } else if (selected_people.value === '10-25') {
    new_filters.speed_minimum = 25
    new_filters.speed_maximum = 50
  } else if (selected_people.value === '25-50') {
    new_filters.speed_minimum = 40
    new_filters.speed_maximum = 70
  } else {
    new_filters.speed_minimum = 55
    new_filters.speed_maximum = 150
  }

  store.SetFilters(new_filters)
  CloseModal()

  // Scroll to products
  nextTick(() => {
    const products_el = document.querySelector('#the-products')
    if (products_el) {
      products_el.scrollIntoView({ behavior: 'smooth' })
    }
  })
}

// --- AI Chat State ---
const ProductImage = store.ProductImage

interface ChatMsg {
  role: 'human' | 'ai'
  message: string
  recommended_products?: any[]
}

const chat_messages = ref<ChatMsg[]>([])
const user_input = ref('')
const is_generating = ref(false)
const chat_body_ref = ref<HTMLElement | null>(null)
const input_ref = ref<HTMLTextAreaElement | null>(null)

function ConfigureProduct(product: any) {
  CloseModal()
  store.ConfigureProduct(product)
}

function GetProductPrice(product: any): number {
  return CalculateProductMonthlyPrice(product)
}

interface ManufacturerDefinition {
  id: number
  name: string
  pattern: RegExp
}

const CATALOG_MANUFACTURERS: ManufacturerDefinition[] = [
  { id: 1, name: 'Xerox', pattern: /\bxerox\b/i },
  { id: 2, name: 'Sharp', pattern: /\bsharp\b/i },
  { id: 3, name: 'HP', pattern: /\b(hp|hewlett[\s-]?packard)\b/i },
  { id: 4, name: 'Konica Minolta', pattern: /\b(konica|minolta|bizhub|konica[\s-]?minolta)\b/i },
  { id: 5, name: 'Ricoh', pattern: /\bricoh\b/i },
  { id: 6, name: 'Canon', pattern: /\bcanon\b/i },
  { id: 7, name: 'Brother', pattern: /\bbrother\b/i },
  { id: 8, name: 'Zultys', pattern: /\bzultys\b/i },
  { id: 9, name: 'Quadient', pattern: /\bquadient\b/i },
  { id: 10, name: 'Lexmark', pattern: /\blexmark\b/i },
  { id: 18, name: 'Epson', pattern: /\bepson\b/i },
  { id: 19, name: 'Kyocera', pattern: /\b(kyocera|taskalfa|ecosys)\b/i },
  { id: 20, name: 'KIP', pattern: /\bkip\b/i },
  { id: 21, name: 'Toshiba', pattern: /\btoshiba\b/i },
  { id: 22, name: 'Zebra', pattern: /\bzebra\b/i },
  { id: 23, name: 'Alfinia Label', pattern: /\b(alfinia|alfinia[\s-]?label)\b/i },
  { id: 24, name: 'Waterlogic', pattern: /\bwaterlogic\b/i },
  { id: 25, name: 'Kodak', pattern: /\bkodak\b/i },
  { id: 26, name: 'Widetek', pattern: /\bwidetek\b/i },
  { id: 27, name: 'Savin', pattern: /\bsavin\b/i },
  { id: 28, name: 'Copystar', pattern: /\bcopystar\b/i },
  { id: 29, name: 'Lanier', pattern: /\blanier\b/i },
  { id: 31, name: 'Dahle', pattern: /\bdahle\b/i },
]

interface UserIntent {
  brand_id: number | null
  brand_name: string | null
  color: 'color' | 'bw' | null
  paper_size: 'a3' | 'a4' | null
  target_speed: number | null
  form_factor: 'desktop' | 'floor' | null
  is_budget: boolean
  is_service: boolean
}

function ParseUserIntent(prompt: string): UserIntent {
  const text = prompt.toLowerCase()

  // 1. Brand Detection (Checking all 23 manufacturers)
  let brand_id: number | null = null
  let brand_name: string | null = null

  for (const man of CATALOG_MANUFACTURERS) {
    if (man.pattern.test(text)) {
      brand_id = man.id
      brand_name = man.name
      break
    }
  }

  // Fallback: check dynamic manufacturers from Pinia store if not matched
  if (!brand_id && manufacturers.value?.length) {
    for (const m of manufacturers.value) {
      if (m.name && m.name.length > 2 && new RegExp(`\\b${m.name.trim()}\\b`, 'i').test(text)) {
        brand_id = Number(m.id)
        brand_name = m.name
        break
      }
    }
  }

  // 2. Color Detection
  let color: 'color' | 'bw' | null = null
  const has_bw = /\b(black\s*(&|and|\+)?\s*white|b&w|bw|monochrome|mono|grayscale)\b/i.test(text)
  const has_color = /\b(color|colour|full[\s-]color)\b/i.test(text)
  if (has_color && !has_bw) {
    color = 'color'
  } else if (has_bw && !has_color) {
    color = 'bw'
  }

  // 3. Paper Size Detection (11x17 / Ledger / Tabloid / A3 vs Letter / A4)
  let paper_size: 'a3' | 'a4' | null = null
  if (/\b(11\s*[x×*]\s*17|ledger|tabloid|a3|large[\s-]format|wide[\s-]format)\b/i.test(text)) {
    paper_size = 'a3'
  } else if (/\b(letter|legal|a4|standard[\s-]paper|regular[\s-]paper)\b/i.test(text)) {
    paper_size = 'a4'
  }

  // 4. Speed / Volume / Prints Detection (e.g. "50 prints", "50 ppm", "50 pages")
  let target_speed: number | null = null
  const speed_match = text.match(/\b(\d{2,3})\s*(?:ppm|prints?|pages?|copies|cpm|speed)\b/i)
  if (speed_match) {
    target_speed = Number(speed_match[1])
  } else {
    const need_speed_match = text.match(/\b(?:need|want|looking for|around|approx|about)\s+(\d{2,3})\b/i)
    if (need_speed_match) {
      target_speed = Number(need_speed_match[1])
    } else {
      const users_match = text.match(/\b(\d{1,3})(?:\s*-\s*|\s+to\s+)(\d{1,3})\s*(?:users?|people|staff)\b/i)
      if (users_match) {
        const avg_users = (Number(users_match[1]) + Number(users_match[2])) / 2
        if (avg_users <= 10) target_speed = 25
        else if (avg_users <= 25) target_speed = 35
        else if (avg_users <= 50) target_speed = 50
        else target_speed = 70
      }
    }
  }

  // 5. Form Factor Detection
  let form_factor: 'desktop' | 'floor' | null = null
  if (/\b(desktop|tabletop|compact|small[\s-]office)\b/i.test(text)) {
    form_factor = 'desktop'
  } else if (/\b(floor|freestanding|high[\s-]capacity|console)\b/i.test(text)) {
    form_factor = 'floor'
  }

  // 6. Budget & Service Intent
  const is_budget = /\b(budget|cheap|low[\s-]cost|under\s*\$?\s*\d+)\b/i.test(text)
  const is_service = /\b(service|maintenance|repair|toner|contract)\b/i.test(text)

  return {
    brand_id,
    brand_name,
    color,
    paper_size,
    target_speed,
    form_factor,
    is_budget,
    is_service
  }
}

function ScoreProduct(p: any, intent: UserIntent, full_text: string): number {
  if (!p.product_image || !IsProductQuotable(p)) return -9999

  let score = 100 // baseline score for any quotable copier with photo

  const name_lower = String(p.name || '').toLowerCase()
  const slug_lower = String(p.slug || '').toLowerCase()
  const man_id = Number(p.manufacturer_id || 0)

  // 1. BRAND CRITERIA (Highest Priority - Strict Isolation)
  if (intent.brand_id) {
    const is_same_man = man_id === intent.brand_id
    const brand_lower = intent.brand_name?.toLowerCase() || ''
    const is_name_match = brand_lower ? name_lower.includes(brand_lower) : false

    if (is_same_man || is_name_match) {
      score += 260 // Decisive boost for requested brand
    } else {
      score -= 360 // Heavy penalty for non-matching brands
    }
  }

  // 2. COLOR CRITERIA
  const raw_color = String(p.copier_color || '').toLowerCase()
  const is_prod_color = raw_color.includes('color')
  const is_prod_bw = raw_color.includes('b&w') || raw_color.includes('black') || raw_color.includes('mono')

  if (intent.color === 'color') {
    if (is_prod_color) score += 70
    else if (is_prod_bw) score -= 150
  } else if (intent.color === 'bw') {
    if (is_prod_bw) score += 70
    else if (is_prod_color) score -= 150
  }

  // 3. PAPER SIZE CRITERIA (11x17 / Ledger / A3)
  const paper_raw = typeof p.paper_size === 'string'
    ? p.paper_size.toLowerCase()
    : JSON.stringify(p.paper_size || '').toLowerCase()
  const is_prod_a3 = paper_raw.includes('a3') || paper_raw.includes('tabloid') || paper_raw.includes('11x17') || paper_raw.includes('ledger')

  if (intent.paper_size === 'a3') {
    if (is_prod_a3) score += 80
    else score -= 160 // Reject A4-only when 11x17 is requested
  } else if (intent.paper_size === 'a4') {
    if (!is_prod_a3) score += 50
  }

  // 4. SPEED / VOLUME / PRINTS CRITERIA
  const prod_speed = Number(p.speed_black || p.speed_color || p.copy_speed || 0)
  if (intent.target_speed && prod_speed > 0) {
    const diff = Math.abs(prod_speed - intent.target_speed)
    if (diff === 0) {
      score += 90 // Exact speed match (e.g. 50 ppm for 50 prints)
    } else if (diff <= 5) {
      score += 60
    } else if (diff <= 10) {
      score += 40
    } else if (diff <= 20) {
      score += 15
    } else {
      score -= 20
    }
  }

  // 5. FORM FACTOR CRITERIA
  const ff = String(p.form_factor || '').toLowerCase()
  if (intent.form_factor === 'desktop') {
    if (ff.includes('desktop') || ff.includes('portable')) score += 40
    else if (ff.includes('floor')) score -= 40
  } else if (intent.form_factor === 'floor') {
    if (ff.includes('floor') || is_prod_a3) score += 40
    else if (ff.includes('desktop')) score -= 30
  }

  // 6. DIRECT MODEL OR SLUG MENTION IN AI CONTEXT
  const words = name_lower.split(/\s+/).filter(w => w.length >= 4 && /\d/.test(w))
  for (const w of words) {
    if (full_text.includes(w)) {
      score += 35
      break
    }
  }
  if (slug_lower && full_text.includes(slug_lower)) {
    score += 40
  }

  // 7. BUDGET CONSIDERATION
  if (intent.is_budget) {
    const price = CalculateProductMonthlyPrice(p)
    if (price > 0 && price <= 99) score += 60
    else if (price > 150) score -= 30
  }

  return score
}

function FindRecommendedProducts(prompt: string, ai_text: string = ''): any[] {
  const all_products = products.value || []
  if (!all_products.length) return []

  const intent = ParseUserIntent(prompt)
  const full_text = `${prompt} ${ai_text}`.toLowerCase()

  // Filter valid quotable copiers with photos and calculate score
  const valid_candidates = all_products.filter(p => p.product_image && IsProductQuotable(p))
  const scored = valid_candidates.map(p => ({
    product: p,
    score: ScoreProduct(p, intent, full_text)
  }))

  // Sort descending by score; tiebreaker by price or speed
  scored.sort((a, b) => {
    if (b.score !== a.score) return b.score - a.score
    const pa = CalculateProductMonthlyPrice(a.product) || 0
    const pb = CalculateProductMonthlyPrice(b.product) || 0
    return pa - pb
  })

  // Pick top matches with positive score
  const positive_matches = scored.filter(s => s.score > 0).slice(0, 3).map(s => s.product)
  if (positive_matches.length > 0) return positive_matches

  // Fallback if no positive score: return top 2 scored candidates
  return scored.slice(0, 2).map(s => s.product)
}

const conversation_starters = [
  { icon: '👥', text: '10–25 user color copier', prompt: 'I need a color copier for an office of 10 to 25 people. What models do you recommend?' },
  { icon: '⚡', text: '11×17 ledger printer', prompt: 'What are your best copiers that support up to 11x17 ledger paper?' },
  { icon: '💵', text: 'Budget lease under $100/mo', prompt: 'Show me reliable multifunction copiers available for lease under $100 per month.' },
  { icon: '🛠️', text: 'Maintenance & repair service', prompt: 'How does your copier maintenance and service contract work?' },
]

function ScrollChatToBottom() {
  nextTick(() => {
    if (chat_body_ref.value) {
      chat_body_ref.value.scrollTop = chat_body_ref.value.scrollHeight
    }
  })
}

function SelectStarter(prompt_text: string) {
  user_input.value = prompt_text
  HandleSendPrompt()
}

function FormatMessage(text: string): string {
  if (!text) return ''
  return text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\n\n/g, '<br/><br/>')
    .replace(/\n/g, '<br/>')
}

// Generate smart local fallback response in case server AI is unreachable
function GenerateFallbackRecommendation(prompt: string, matched_prods: any[]): string {
  if (matched_prods && matched_prods.length > 0) {
    const list_items = matched_prods.map(p => {
      const specs = FormatProductSpecsSummary(p)
      const price = CalculateProductMonthlyPrice(p)
      const price_text = price > 0 ? `Starts at ~$${price}/mo` : 'Competitive lease pricing'
      return `• <strong>${p.name}</strong> (${specs}) — ${price_text}. Feature-rich commercial multifunction system with dual-scan ADF, high-yield supplies, and all-inclusive maintenance.`
    }).join('<br/>')

    const intent = ParseUserIntent(prompt)
    const traits: string[] = []
    if (intent.brand_name) traits.push(`<strong>${intent.brand_name.toUpperCase()}</strong>`)
    if (intent.color === 'color') traits.push('<strong>Color</strong>')
    if (intent.color === 'bw') traits.push('<strong>Monochrome</strong>')
    if (intent.paper_size === 'a3') traits.push('<strong>11×17 (Ledger/Tabloid)</strong>')
    if (intent.target_speed) traits.push(`<strong>${intent.target_speed} ppm/prints</strong>`)

    const header = traits.length > 0
      ? `Here are our top equipment recommendations matching ${traits.join(', ')}`
      : 'Based on your office requirements, here are excellent options from our catalog'

    return `${header}:<br/><br/>` +
      `${list_items}<br/><br/>` +
      `Click <strong>Configure →</strong> on any model below to customize paper drawers, accessories, and review instant lease options!`
  }

  return `Based on your requirements, here are excellent options tailored for your office:<br/><br/>` +
    `• <strong>Mid-Volume Color MFP:</strong> Sharp BP-70C35 (35 ppm, ideal for 10–25 users, color touch-screen).<br/>` +
    `• <strong>High-Volume Enterprise:</strong> Xerox AltaLink C8170 (70 ppm, heavy duty, security certified).<br/>` +
    `• <strong>Cost-Efficiency Leader:</strong> Kyocera TASKalfa 3554ci (ultra-reliable with low CPP).<br/><br/>` +
    `Click <strong>Configure →</strong> on any recommended model below to get started!`
}

async function HandleSendPrompt() {
  const prompt_text = user_input.value.trim()
  if (!prompt_text || is_generating.value) return

  // Push user message
  chat_messages.value.push({ role: 'human', message: prompt_text })
  user_input.value = ''
  is_generating.value = true
  ScrollChatToBottom()

  // Parse user criteria and pre-match top inventory models
  const intent = ParseUserIntent(prompt_text)
  const matched_for_context = FindRecommendedProducts(prompt_text, '')
  const catalog_sample = matched_for_context.slice(0, 3).map(p => {
    const monthly = CalculateProductMonthlyPrice(p)
    const msrp = p.advertising_price ? `$${Number(String(p.advertising_price).replace(/[$,]/g, '')).toLocaleString()}` : 'Custom'
    const speed = p.speed_black || p.copy_speed || 'N/A'
    const color = p.copier_color || 'Color'
    const specs = FormatProductSpecsSummary(p)
    const mono_cpp = p.mono_cpp ? `${(Number(p.mono_cpp) * 100).toFixed(2)}¢/bw` : ''
    const color_cpp = p.color_cpp ? `${(Number(p.color_cpp) * 100).toFixed(2)}¢/color` : ''
    const cpp_str = (mono_cpp || color_cpp) ? ` | CPP: ${[mono_cpp, color_cpp].filter(Boolean).join(', ')}` : ''

    return `- ${p.name} [${specs}]: Est Lease: $${monthly}/mo | Purchase: ${msrp} | Speed: ${speed} ppm | Color: ${color}${cpp_str}`
  }).join('\n')

  let brand_instruction = 'We offer commercial copiers from Xerox, Sharp, HP, Konica Minolta, Ricoh, Canon, Brother, Lexmark, Kyocera, Toshiba, Epson, and more.'
  if (intent.brand_name) {
    brand_instruction = `The user specifically asked for ${intent.brand_name.toUpperCase()} brand equipment. You MUST focus your recommendations on ${intent.brand_name.toUpperCase()} models from our inventory!`
  }

  const history_payload = [
    {
      role: 'system',
      content: `You are a friendly, knowledgeable 1-800 Office Solutions AI copier specialist.
${brand_instruction}
Always honor the user's explicit criteria: brand, speed/volume (e.g. 50 ppm/prints), paper size (e.g. 11x17/Ledger), and color vs B&W.
Relevant matching models currently in our inventory:
${catalog_sample}
Recommend these exact models concisely with bullet points and encourage the user to click Configure.`
    },
    ...chat_messages.value.map(msg => ({
      role: msg.role === 'human' ? 'user' : 'assistant',
      content: msg.message
    }))
  ]

  const form_data = new FormData()
  form_data.append('history', JSON.stringify(history_payload))

  try {
    const res = await axios.post('/wp-json/1-800-products/v1/assistant/send-prompt', form_data, { timeout: 12000 })
    const ai_content = res.data?.choices?.[0]?.message?.content
    if (ai_content) {
      chat_messages.value.push({
        role: 'ai',
        message: ai_content,
        recommended_products: FindRecommendedProducts(prompt_text, ai_content)
      })
    } else {
      const fallback = GenerateFallbackRecommendation(prompt_text, matched_for_context)
      chat_messages.value.push({
        role: 'ai',
        message: fallback,
        recommended_products: matched_for_context
      })
    }
  } catch (err) {
    console.warn('AI backend unavailable, using local intelligence engine:', err)
    const fallback = GenerateFallbackRecommendation(prompt_text, matched_for_context)
    chat_messages.value.push({
      role: 'ai',
      message: fallback,
      recommended_products: matched_for_context
    })
  } finally {
    is_generating.value = false
    ScrollChatToBottom()
  }
}
</script>

<style scoped lang="scss">
// Overlay Backdrop
.hmc-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(11, 18, 32, 0.48);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  padding: 16px;
}

// Modal Card
.mcard {
  position: relative;
  width: min(600px, 94vw);
  background: #ffffff;
  border-radius: 20px;
  padding: 24px 26px 22px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.28);
  font-family: inherit;
  color: #0b1220;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &.ai-mode {
    padding: 22px 24px 18px;
    height: 640px;
  }
}

// Close Button (Circle in top-right)
.mx {
  position: absolute;
  right: 16px;
  top: 14px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475264;
  transition: all 0.15s ease;
  z-index: 10;

  &:hover {
    background: #f1f5f9;
    color: #0b1220;
    border-color: #cbd5e1;
  }
}

// Mode Tabs
.mode-tabs {
  display: inline-flex;
  align-self: flex-start;
  background: #f1f5f9;
  padding: 3px;
  border-radius: 12px;
  margin-bottom: 14px;
  gap: 2px;
}

.mode-tab-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 9px;
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s ease;

  .tab-icon {
    width: 14px;
    height: 14px;
  }

  &.active {
    background: #ffffff;
    color: #1b5fd1;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  &:hover:not(.active) {
    color: #1e293b;
  }
}

// Eyebrow & Headings
.m-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #1b5fd1;
  display: block;
}

h3 {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0b1220;
  margin: 4px 0 2px;
}

// ================= QUIZ MODE STYLES =================
.quiz-view-container {
  overflow-y: auto;
  padding-right: 4px;
}

.mq {
  margin-top: 13px;
}

.ql {
  font-size: 13px;
  font-weight: 700;
  color: #334155;
  margin-bottom: 7px;
}

.qchips {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;

  &.c3 {
    grid-template-columns: repeat(3, 1fr);
  }

  &.c2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

.qchip {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  border: 1.5px solid #e2e8f0;
  border-radius: 14px;
  padding: 9px 6px;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.15s ease;

  svg {
    width: 24px;
    height: 24px;
    color: #64748b;
  }

  &:hover {
    border-color: #94a3b8;
    background: #f8fafc;
  }

  &.on {
    border-color: #1b5fd1;
    background: #eff6ff;
    color: #1d4ed8;

    svg {
      color: #1b5fd1;
    }
  }
}

.btn-b {
  width: 100%;
  margin-top: 18px;
  padding: 13px 18px;
  background: #1b5fd1;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.01em;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(27, 95, 209, 0.3);
  transition: all 0.15s ease;

  &:hover {
    background: #154bb3;
    box-shadow: 0 6px 18px rgba(27, 95, 209, 0.4);
  }
}

.mai {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 600;
  color: #1b5fd1;
  cursor: pointer;
  text-decoration: none;

  svg {
    width: 15px;
    height: 15px;
  }

  &:hover {
    text-decoration: underline;
  }
}

// ================= AI MODE STYLES =================
.ai-view-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.ai-header {
  margin-bottom: 12px;

  .ai-desc {
    font-size: 12.5px;
    color: #64748b;
    margin: 4px 0 0;
    line-height: 1.4;
  }
}

.ai-chat-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px 4px 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
}

.chat-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;

  &.user {
    justify-content: flex-end;
  }

  &.bot {
    justify-content: flex-start;
  }
}

.bot-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1b5fd1, #7c3aed);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(27, 95, 209, 0.25);

  .sparkle-avatar {
    width: 18px;
    height: 18px;
  }
}

.bubble {
  max-width: 82%;
  padding: 11px 15px;
  font-size: 13px;
  line-height: 1.5;

  &.user-bubble {
    background: #1b5fd1;
    color: #ffffff;
    border-radius: 16px 16px 4px 16px;
    box-shadow: 0 4px 12px rgba(27, 95, 209, 0.2);
  }

  &.bot-bubble {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    color: #1e293b;
    border-radius: 4px 16px 16px 16px;

    &:has(.ai-prod-grid) {
      max-width: 95%;
      width: 100%;
    }
  }
}

// Recommended Product Cards in Chat Bubble
.ai-prod-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
}

.ai-prod-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 2px 6px rgba(11, 18, 32, 0.04);

  &:hover {
    border-color: #1b5fd1;
    box-shadow: 0 6px 16px rgba(27, 95, 209, 0.12);
    transform: translateY(-1.5px);

    .ai-prod-btn {
      background: #154bb3;
    }
  }
}

.ai-prod-thumb-box {
  position: relative;
  width: 76px;
  height: 76px;
  flex-shrink: 0;
  background: #f8fafc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #edf2f7;

  .ai-prod-thumb {
    max-width: 90%;
    max-height: 90%;
    object-fit: contain;
  }

  .ai-prod-badge {
    position: absolute;
    bottom: 2px;
    left: 2px;
    right: 2px;
    font-size: 8px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    background: rgba(16, 185, 129, 0.9);
    color: #ffffff;
    border-radius: 4px;
    padding: 1px 2px;
    letter-spacing: 0.02em;
  }
}

.ai-prod-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.ai-prod-capsule {
  font-size: 10px;
  font-weight: 700;
  color: #1b5fd1;
  background: #eff6ff;
  border-radius: 4px;
  padding: 2px 6px;
  width: fit-content;
  letter-spacing: 0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.ai-prod-title {
  font-size: 13px;
  font-weight: 700;
  color: #0b1220;
  margin: 3px 0 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.25;
}

.ai-prod-inc {
  font-size: 10.5px;
  font-weight: 600;
  color: #059669;
  margin-bottom: 4px;
}

.ai-prod-action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
}

.ai-prod-price {
  display: flex;
  align-items: baseline;
  gap: 4px;

  .est {
    font-size: 9px;
    font-weight: 700;
    color: #94a3b8;
    letter-spacing: 0.04em;
  }

  .val {
    font-size: 14px;
    font-weight: 800;
    color: #0b1220;
    letter-spacing: -0.02em;

    small {
      font-size: 10.5px;
      font-weight: 500;
      color: #64748b;
    }

    &.custom-quote {
      font-size: 12px;
      font-weight: 700;
      color: #475569;
    }
  }
}

.ai-prod-btn {
  background: #1b5fd1;
  color: #ffffff;
  border: none;
  border-radius: 7px;
  padding: 5px 12px;
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(27, 95, 209, 0.25);

  &:hover {
    background: #154bb3;
    box-shadow: 0 4px 10px rgba(27, 95, 209, 0.35);
  }
}

// Starters
.starters-wrap {
  margin: 6px 0 4px;
}

.starters-label {
  font-size: 11.5px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.starters-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.starter-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;

  .starter-icon {
    font-size: 14px;
  }

  &:hover {
    border-color: #1b5fd1;
    background: #eff6ff;
    color: #1d4ed8;
  }
}

// Typing Indicator
.typing-bubble {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 12px 16px;
}

.typing-dot {
  width: 6px;
  height: 6px;
  background: #94a3b8;
  border-radius: 50%;
  animation: typingBounce 1.2s infinite ease-in-out;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    animation-delay: 0.4s;
  }
}

@keyframes typingBounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

// Input Area
.ai-input-area {
  margin-top: 8px;
  padding-top: 10px;
  border-top: 1px solid #f1f5f9;
}

.prompt-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 4px 6px 4px 12px;
  transition: border-color 0.15s ease;

  &:focus-within {
    border-color: #1b5fd1;
    background: #ffffff;
    box-shadow: 0 0 0 3px rgba(27, 95, 209, 0.12);
  }
}

.prompt-textarea {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  resize: none;
  font-size: 13px;
  color: #0b1220;
  font-family: inherit;
  padding: 6px 0;
  line-height: 1.4;

  &::placeholder {
    color: #94a3b8;
  }
}

.send-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #1b5fd1;
  border: none;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s ease;

  svg {
    width: 15px;
    height: 15px;
  }

  &:hover:not(:disabled) {
    background: #154bb3;
  }

  &:disabled {
    background: #cbd5e1;
    cursor: not-allowed;
  }
}

.ai-footer-note {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 11px;
  color: #94a3b8;

  .switch-link {
    color: #1b5fd1;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
}

// Fade Animation
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
